import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GuestRoleService, NotificationDialogComponent } from 'app/shared';
import { GuestRole } from 'app/shared/models/guest-role.model';
import { Role } from 'app/shared/models/role.model';

@Component({
    selector: 'app-role-form',
    templateUrl: './role-form.component.html',
    styleUrls: ['./role-form.component.scss'],
    standalone: false
})
export class RoleFormComponent implements OnInit {
  @Input({ required: true }) guestRole!: GuestRole;
  @Input({ required: true }) roles!: Role[];
  @Input() edit: boolean = false;

  currentDate: Date = new Date();
  maxEndDate: Date = new Date();

  isNetworkAccountSetup: boolean | undefined = undefined;
  isSending: boolean | undefined = undefined;

  selectedRole: Role | undefined = undefined;

  constructor(private guestRoleService: GuestRoleService, private dialog: MatDialog) { }

  ngOnInit() {
    this.getSelectedRole()
    if (this.guestRole?.guest?.iNumber && this.guestRole?.guestRoleId) {
      this.guestRoleService.getNetworkAccountStatus(this.guestRole.guest.iNumber, this.guestRole.guestRoleId)
        .subscribe(status => {
          this.isNetworkAccountSetup = status.isAccountSetup;
        });
    }
  }

  getSelectedRole() {
    this.selectedRole = this.roles.find(r => r.roleId == this.guestRole.roleId);
    if (this.selectedRole?.monthLimit) {
      this.maxEndDate = new Date(); // Reset max end date to today, then add months again from today's date.
      this.maxEndDate.setMonth(this.currentDate.getMonth() + this.selectedRole.monthLimit);

      // Clear end date if it is bigger than the new max end date.
      if (this.guestRole?.endDate && this.guestRole.endDate > this.maxEndDate) {
        this.guestRole.endDate = undefined;
      }
    }
  }

  public resendAccountSetupEmail() {
    if (this.isSending !== false) {
      this.isSending = true;
      this.guestRoleService.resendSetupEmail(this.guestRole.guest.iNumber, this.guestRole.guestRoleId)
        .subscribe({
          next: () => {
            this.isSending = false;
            this.openNotificationDialog("Email sent successfully", "Email successfully sent again.");
          },
          error: (e: HttpErrorResponse) => {
            this.isSending = false;
            this.openNotificationDialog("Error sending email", e.error.message);
          }
        });
    }
  }

  // TODO: This method has been copied from a few other places, and really should be moved to a centralized service!
  openNotificationDialog(titleMessage: string, contentMessage: string) {
    const notificationDialog = this.dialog.open(NotificationDialogComponent, {
      data: {
        title: titleMessage,
        content: contentMessage,
      }
    });

    notificationDialog.afterClosed().subscribe(
      result => {
      }
    );
  }
}